// Boiler Plate Imports
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { update as setBreadCrumbs } from "../../redux-store/breadCrumbsSlice";
// Conatiner Component Imports
import BreadCrumbs from "../../components/Navigation/breadcrumbs";
import { Button, TextField } from "@mui/material";
import API from "../../api";
import ErrorIcon from "@mui/icons-material/Error";
import { InfoIcon, WarningIcon } from "../../theme/icons";

import {
  FormContainer,
  FormSubmitError,
  ActionButtonsContainer,
} from "../../components/Forms/shared";

import {
  remove as removeNotification,
  add as addNotification,
} from "../../redux-store/notificationsSlice";

// Page Component Imports
import MetricBoxesComponent from "../../components/Page/metricBoxes";
import TanksTableWidget from "../../components/Widgets/tanksTableWidget";
import styled from "styled-components";

import { GRID_CHECKBOX_SELECTION_COL_DEF } from "@mui/x-data-grid-pro";
import ModalComponent from "../../components/Modal";
import FormFieldErrorClass from "../../components/Forms/models/formFieldError";
import colors from "../../theme/colors";

const PaddingWrapper = styled.div`
  padding: 0 15px 10px;
  @media (max-width: 1080px) {
    padding: 0 0px 10px;
  }
`;

const FlexDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const DialogBold = styled.div`
  margin-top: 10px;
  font-weight: bold;
`;

const DialogGrayText = styled.span`
  color: ${colors.grayDark};
`;

const InfoText = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: ${colors.orange};
  border-bottom: 1px solid ${colors.grayLight};
  padding-bottom: 10px;
`;

const SelectTanksTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 10px 0;

  th,
  td {
    border: 1px solid ${colors.grayLight};
    padding: 8px;
    text-align: left;
  }

  th {
    background-color: ${colors.grayLighter};
  }
`;

const AdminTanksContainer = () => {
  const [metrics, setMetrics] = useState([]);
  const dispatch = useDispatch();

  const [saving, setSaving] = useState(false);
  const [savingError, setSavingError] = useState("");

  const [reloadData, setReloadData] = useState(false);

  const [showMoveTanksDialog, setShowMoveTanksDialog] = useState(false);
  const [selectedTankIds, setSelectedTankIds] = useState([]);
  const [selectedTanks, setSelectedTanks] = useState([]);

  const [organizations, setOrganizations] = useState([]);
  const [selectedOrganizationId, setSelectedOrganizationId] = useState("");
  const [isLoadingOrganizations, setIsLoadingOrganizations] = useState(true);

  const [locations, setLocations] = useState([]);
  const [selectedLocationId, setSelectedLocationId] = useState("");
  const [isLoadingLocations, setIsLoadingLocations] = useState(true);
  const [locationsError, setLocationsError] = useState(
    new FormFieldErrorClass(),
  );

  const [showWarningModal, setShowWarningModal] = useState(false);
  const [preValidationError, setPreValidationError] = useState(
    new FormFieldErrorClass(),
  );

  useEffect(() => {
    dispatch(
      setBreadCrumbs([
        {
          title: "Admin Tanks",
          link: "/admin/tanks",
        },
      ]),
    );
    setMetrics([
      {
        title: "TOTAL TANKS",
        value: "--",
      },
    ]);
  }, []);

  useEffect(() => {
    console.log("Selected Organization ID changed:", selectedOrganizationId);
    dataLayer.getOrganizationLocations(selectedOrganizationId);
  }, [selectedOrganizationId]);

  useEffect(() => {
    if (isLoadingLocations) return;
    validate.locations(locations);
  }, [locations]);

  useEffect(() => {
    if (showMoveTanksDialog) {
      dataLayer.getAllOrganiations();
    }
  }, [showMoveTanksDialog]);

  const dataLayer = {
    getAllOrganiations: async () => {
      setIsLoadingOrganizations(true);
      const _orgs = await API.Organization.OrganizationsGetAll();
      setOrganizations(_orgs.organizations);
      setSelectedOrganizationId(_orgs.organizations[0]?.id || null);
      setIsLoadingOrganizations(false);
    },
    getOrganizationLocations: async (organizationId) => {
      if (!organizationId) return;
      setSelectedLocationId("");
      setIsLoadingLocations(true);
      const _locations = await API.Location.LocationsGet({ organizationId });
      setLocations(_locations);
      const _selectedLocationId = _locations[0]?.id || "";
      console.log("_selectedLocationId", _selectedLocationId);
      setSelectedLocationId(_selectedLocationId);
      setIsLoadingLocations(false);
    },
    saveMoveTanks: async () => {
      setSavingError("");
      setSaving(true);
      try {
        console.log({
          tankIds: selectedTankIds,
          locationId: selectedLocationId,
        });
        await API.Tank.TanksMove({
          tankIds: selectedTankIds,
          locationId: selectedLocationId,
        });
        setReloadData(true);
        handlers.cancel();
        const id = new Date().getTime();
        dispatch(
          addNotification({
            id,
            severity: "success",
            title: "Success",
            message: "Tanks Moved Successfully",
          }),
        );
        setTimeout(() => {
          dispatch(removeNotification(id));
        }, 3000);
      } catch (err) {
        setSavingError(err);
        console.log(err);
        const id = new Date().getTime();
        dispatch(
          addNotification({
            id,
            severity: "error",
            title: "Error",
            message: err,
          }),
        );
        setTimeout(() => {
          dispatch(removeNotification(id));
        }, 3000);
      }
      setSaving(false);
    },
  };

  const validate = {
    locations: (value) => {
      setLocationsError({
        hasError: false,
        message: "",
      });
      if (!value || value.length === 0) {
        setLocationsError({
          hasError: true,
          message:
            "Organization has no locations, please select a different Organization.",
        });
        return;
      }
    },
    selectedTanks: (value) => {
      setPreValidationError({
        hasError: false,
        message: "",
      });

      if (value.length > 10) {
        setPreValidationError({
          hasError: true,
          message: "You may only select 10 tanks at once to move.",
          body: (
            <div>
              <p>You currently have selected too many tanks.</p>{" "}
              <p>Please edit selection in order to move tanks.</p>
            </div>
          ),
        });
        setShowWarningModal(true);
        return false;
      }
      //check that all selected tanks are from the same location
      const locationIds = new Set(value.map((tank) => tank.location.id));
      if (locationIds.size > 1) {
        setPreValidationError({
          hasError: true,
          message:
            "All tanks selected must be from the same Organization and Location in order to move tanks.",
          body: (
            <div>
              <p>
                You currently have selected tanks from multiple Organizations
                and/or Locations.
              </p>
              <p>Please edit selection in order to move tanks.</p>
            </div>
          ),
        });
        setShowWarningModal(true);
        return false;
      }
      return true;
    },
  };

  const handlers = {
    moveTanksButtonClick: (_selectedTankIds, _selectedTanks) => {
      console.log("Move Tanks Clicked with IDs:", _selectedTankIds);
      console.log("Selected Tanks:", _selectedTanks);
      setOrganizations([]);
      setLocations([]);
      setSelectedTanks(_selectedTanks);
      setSelectedTankIds(_selectedTankIds);
      setSelectedLocationId("");
      setSelectedOrganizationId("");
      setSavingError("");
      setLocationsError({
        hasError: false,
        message: "",
      });
      setIsLoadingLocations(true);
      setIsLoadingOrganizations(true);
      //before we open the dialog, validate the selected tanks
      if (validate.selectedTanks(_selectedTanks)) {
        setShowMoveTanksDialog(true);
      }
    },
    cancel: () => {
      setShowMoveTanksDialog(false);
    },
    organizationChange: ({ target }) => {
      setSelectedOrganizationId(target.value);
    },
    moveTanksSubmit: async () => {
      await dataLayer.saveMoveTanks();
    },
  };

  return (
    <>
      
      <MetricBoxesComponent title={""} metrics={metrics} />
      <PaddingWrapper>
        <TanksTableWidget
          isAdminView={true}
          reloadData={reloadData}
          initalState={{
            pinnedColumns: {
              left: [
                GRID_CHECKBOX_SELECTION_COL_DEF.field,
                "organizationName",
                "name",
              ],
            },
            columns: {
              columnVisibilityModel: {
                // Hide weight trend column
                weightTrend: false,
              },
            },
            filter: {
              filterModel: {
                items: [
                  {
                    field: "statusDescription",
                    operator: "doesNotContain",
                    value: "deactivated",
                  },
                ],
              },
            },
          }}
          subHeader={"View all tanks in the Boreas system below"}
          enableMoveTanks={true}
          moveTanksCallback={handlers.moveTanksButtonClick}
          doneLoadingData={(data) => {
            setMetrics([
              {
                title: "TOTAL TANKS",
                value: data.length,
              },
            ]);
            console.log(data);
            setReloadData(false);
          }}
        />
      </PaddingWrapper>
      <ModalComponent
        open={showMoveTanksDialog}
        handleClose={() => setShowMoveTanksDialog(false)}
        headerText={
          <div>
            Move Tanks
            <DialogGrayText>
              {" "}
              / from {selectedTanks[0]?.organization.name}
            </DialogGrayText>
          </div>
        }
      >
        <FormContainer>
          <div>
            You have selected the tanks below to move from{" "}
            <b>
              {selectedTanks[0]?.organization.name} -{" "}
              {selectedTanks[0]?.location.name}.
            </b>{" "}
            Select the new Organization and Location where you want to move all
            tanks listed below. Only 10 tanks can be moved at once.
          </div>
          <InfoText>
            <InfoIcon />
            All tank data will be copied to the new location selected. This
            cannot be undone.
          </InfoText>

          <DialogBold>Moving Tanks</DialogBold>
          <SelectTanksTable>
            <thead>
              <tr>
                <th>Tank Name</th>
                <th>Organization</th>
                <th>Location</th>
              </tr>
            </thead>
            <tbody>
              {selectedTanks.map((tank) => (
                <tr key={tank.id}>
                  <td>{tank.name}</td>
                  <td>{tank.organization.name}</td>
                  <td>{tank.location.name}</td>
                </tr>
              ))}
            </tbody>
          </SelectTanksTable>

          <DialogBold>To the following Organization and Location</DialogBold>

          <TextField
            id="organization-id"
            select
            variant="outlined"
            label="New Organization"
            value={selectedOrganizationId || "loading"}
            helperText={""}
            error={false}
            slotProps={{
              select: {
                native: true,
              },
            }}
            onChange={handlers.organizationChange}
            disabled={isLoadingOrganizations}
          >
            {isLoadingOrganizations ? (
              <option value="loading">Loading...</option>
            ) : (
              organizations.map((item) => {
                return (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                );
              })
            )}
          </TextField>

          <TextField
            id="location-id"
            select
            variant="outlined"
            label="New Location"
            value={selectedLocationId || "loading"}
            helperText={locationsError.message}
            error={locationsError.hasError}
            slotProps={{
              select: {
                native: true,
              },
            }}
            disabled={isLoadingLocations}
            onChange={(e) => setSelectedLocationId(e.target.value)}
          >
            {isLoadingLocations ? (
              <option value="loading">Loading...</option>
            ) : (
              locations.map((item) => {
                return (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                );
              })
            )}
          </TextField>

          {savingError && (
            <FormSubmitError>
              <ErrorIcon fontSize="small" />
              {savingError}
            </FormSubmitError>
          )}

          <ActionButtonsContainer>
            <Button
              variant="outlined"
              color="primary"
              onClick={handlers.cancel}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handlers.moveTanksSubmit}
              disabled={
                saving ||
                isLoadingLocations ||
                isLoadingOrganizations ||
                locationsError.hasError
              }
            >
              Confirm Move
            </Button>
          </ActionButtonsContainer>
        </FormContainer>
      </ModalComponent>
      <ModalComponent
        open={showWarningModal}
        handleClose={() => {
          setShowWarningModal(false);
        }}
        headerText={
          <FlexDiv>
            <WarningIcon style={{ color: colors.redError }} />
            Action Cannot Be Completed
            <DialogGrayText>/ Move Tanks</DialogGrayText>
          </FlexDiv>
        }
      >
        <FormContainer>
          <DialogBold>{preValidationError.message}</DialogBold>
          {preValidationError.body}
          <ActionButtonsContainer>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setShowWarningModal(false);
              }}
            >
              OK
            </Button>
          </ActionButtonsContainer>
        </FormContainer>
      </ModalComponent>
    </>
  );
};

export default AdminTanksContainer;
